import { render, staticRenderFns } from "./documentActionsDialog.vue?vue&type=template&id=55c7685d&scoped=true"
import script from "./documentActionsDialog.vue?vue&type=script&lang=js"
export * from "./documentActionsDialog.vue?vue&type=script&lang=js"
import style0 from "./documentActionsDialog.vue?vue&type=style&index=0&id=55c7685d&prod&scoped=true&lang=css"
import style1 from "./documentActionsDialog.vue?vue&type=style&index=1&id=55c7685d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c7685d",
  null
  
)

export default component.exports